import SearchBar from "../../components/group/toolbar/SearchBar"

export default function GroupManager() {
    return (
        <div className="m-10">
            <SearchBar/>
        </div>
    )
}